import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface LegalSection {
  id: string;
  title: string;
  content: string;
}

export interface LegalDocumentContent {
  document_type: string;
  version: string;
  sections: LegalSection[];
  last_updated: string;
  effective_date: string;
  entity_name: string;
  entity_type: string;
  min_age: number;
}

export function useLegalContent(documentType: 'terms_of_service' | 'privacy_policy') {
  const [content, setContent] = useState<LegalDocumentContent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchContent() {
      try {
        const { data, error } = await supabase.rpc('get_legal_document_content', {
          p_document_type: documentType
        });
        if (!error && data) {
          const parsed = typeof data === 'string' ? JSON.parse(data) : data;
          if (parsed && parsed.sections && parsed.sections.length > 0) {
            setContent(parsed);
          }
        }
      } catch {
        // Fall through to hardcoded content
      } finally {
        setLoading(false);
      }
    }
    fetchContent();
  }, [documentType]);

  return { content, loading };
}
